<template>
	<legend v-if="legend" :class="classes" data-testid="label">
		<slot></slot>
	</legend>

	<label v-else :for="field" :class="classes" data-testid="label">
		<slot></slot>
	</label>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	const props = withDefaults(
		defineProps<{
			field?: string
			inline?: boolean
			legend?: boolean
		}>(),
		{
			inline: false,
			field: '',
			legend: false
		}
	)

	const classes = computed(() => ({
		'block text-sm font-medium leading-6 text-gray-900': true,
		'sm:mt-1.5': props.inline
	}))
</script>
